<template>
  <div class="echarts" id="drugLeftthree"></div>
</template>
<script>
import { defineComponent, reactive, toRefs, onMounted } from "vue";

import * as echarts from "echarts";
export default defineComponent({
  name: "",
  components: {},
  props: {},
  setup(props) {
    onMounted(() => {
      const myChart = echarts.init(document.getElementById("drugLeftthree"));
      myChart.setOption({
        grid: {
          top: 40,
          left: 50,
          right: 30,
          bottom: 50
          // containLabel: true
        },
        xAxis: {
          data: ["02-21", "02-22", "02-23", "02-24", "02-25", "02-26", "02-27"],
          axisLabel: {
            show: true,
            textStyle: {
              color: "#fff"
            }
          },
          axisLine: {
            lineStyle: {
              color: "#08598f" // 横坐标线条颜色
            }
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true,
            textStyle: {
              color: "#fff"
            }
          },
          splitLine: {
            // 网格线
            lineStyle: {
              color: "#08598f",
              type: "dashed" // 设置网格线类型 dotted：虚线   solid:实线
            },
            show: true // 隐藏或显示
          }
        },
        series: [
          {
            data: [820, 932, 901, 934, 1290, 1330, 1320],
            type: "line",
            smooth: true,
            itemStyle: {
              normal: {
                color: "#6881cc", // 折点颜色
                lineStyle: {
                  color: "#6881cc" // 折线颜色
                }
              }
            }
          }
        ]
      });
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    });

    return {};
  }
});
</script>
<style lang="scss" scoped>
#drugLeftthree {
  width: 100%;
  height: 90%;
}
</style>
